// TASK-K2T-15 — pure display helpers for the TCA tab (execution measurement against the
// independent quote-tape witness, ADR-0030). Every verdict and aggregate is SERVER-computed — one
// TcaSnapshot (GET /api/autotrader/{id}/tca) so every surface shows identical numbers; this module
// only formats. Nulls are honest absence and render the dash; signed figures carry an EXPLICIT
// sign (design rule: never encode direction by color alone; U+2212 minus).

/** Signed basis points: `+12.3` / `−8.0` / `0.0`; null/undefined → the honest dash. */
export function fmtBps(v, dp = 1) {
  if (v == null) return '—';
  const abs = Math.abs(v).toFixed(dp);
  if (v > 0) return `+${abs}`;
  if (v < 0) return `−${abs}`;
  return abs;
}

/** Wire policy → display label; unknown values pass through untranslated (never mislabeled). */
export function policyLabel(policy) {
  switch (policy) {
    case 'twap': return 'TWAP';
    case 'market': return 'Market';
    default: return String(policy ?? '—');
  }
}

/**
 * CSS tone for a signed cost/drift figure (color REINFORCES the explicit sign, never replaces it):
 * positive = adverse ('tca-adverse'), negative = favorable ('tca-favorable'), zero/null = ''.
 */
export function bpsTone(v) {
  if (v == null) return '';
  return v > 0 ? 'tca-adverse' : v < 0 ? 'tca-favorable' : '';
}

/** Compact USD for the frontier cells: $25.0k / $1.2M / $950; null → dash. */
export function fmtCompactUsd(v) {
  if (v == null) return '—';
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `$${(v / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `$${(v / 1_000).toFixed(1)}k`;
  return `$${Math.round(v)}`;
}
